exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download-app-button[data-v-76922493] {\n  display: inline-block;\n}\n.download-app-button a[data-v-76922493] {\n  color: inherit;\n}", ""]);

// exports
